import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useExperimentFlag, useExperimentFlagDetail } from '@zenbusiness/application-commons-experiments';
import { gql, useQuery } from '@zenbusiness/application-commons-graphql';
import { useError } from '@zenbusiness/application-commons-logging';

import { ENABLE_CA_FILING_ACCESS_BANNER, WFC_PAST_DUE_BANNER_CTA_EXPERIMENT } from '#client/constants/experimentsFlags';

export const BANNERS_QUERY = gql`
  query Banners(
    $businessEntityUuid: UUID!
    $enableCAFilingAccessBanner: Boolean
    $wfcPastDueBannerCtaExperiment: String
  ) {
    banners(
      filter: {
        businessEntityUuid: $businessEntityUuid
        experiment: {
          enableCAFilingAccessBanner: $enableCAFilingAccessBanner
          wfcPastDueBannerCtaExperiment: $wfcPastDueBannerCtaExperiment
        }
      }
    ) {
      title
      description
      type
      imageUrl
      imageSize
      raised
      dismissible
      storageKey
      experiment {
        featureFlagKey
        featureFlagVariation
      }
      primaryCta {
        label
        modalName
        url
      }
      secondaryCta {
        label
        modalName
        url
      }
    }
  }
`;

export function useBanners() {
  const { businessEntityUuid } = useBusinessEntity();
  const enableCAFilingAccessBanner = useExperimentFlag(ENABLE_CA_FILING_ACCESS_BANNER, false);
  const { value: wfcPastDueBannerCtaExperiment, reason } = useExperimentFlagDetail(
    WFC_PAST_DUE_BANNER_CTA_EXPERIMENT,
    null,
  );

  const { data, loading, error } = useQuery(BANNERS_QUERY, {
    noThrow: true,
    variables: {
      businessEntityUuid,
      enableCAFilingAccessBanner,
      wfcPastDueBannerCtaExperiment,
    },
  });

  useError(error);

  return {
    data: data?.banners || [],
    error,
    inWfcPastDueBannerCtaExperiment: reason?.inExperiment ?? false,
    loading,
  };
}
